var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkcircleoutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8333 0C9.34583 0 0 9.34583 0 20.8333C0 32.3208 9.34583 41.6667 20.8333 41.6667C32.3208 41.6667 41.6667 32.3208 41.6667 20.8333C41.6667 9.34583 32.3208 0 20.8333 0ZM20.8333 37.5C11.6438 37.5 4.16667 30.0229 4.16667 20.8333C4.16667 11.6438 11.6438 4.16667 20.8333 4.16667C30.0229 4.16667 37.5 11.6438 37.5 20.8333C37.5 30.0229 30.0229 37.5 20.8333 37.5Z",
    fill: "#1FC16B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6646 24.1396L11.8751 19.3584L8.93338 22.3084L16.6688 30.0271L30.6396 16.0563L27.6938 13.1105L16.6646 24.1396Z",
    fill: "#1FC16B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkcircleoutline);
export default __webpack_public_path__ + "static/media/checkmark.circle.outline.c95d573e5bc9bf4538ad00ca2b6d7d8c.svg";
export { ForwardRef as ReactComponent };